export let sliderImg=[
    {
      id:1,
      src:'/skydome images/Slide-img1.webp',
    },
    {
      id:2,
      src:'/skydome images/Slide-img2.webp',
    },
    {
      id:3,
      src:'/skydome images/Slide-img3.webp',
    },
    {
      id:4,
      src:'/skydome images/Slide-img4.webp',
    },
    {
      id:5,
      src:'/skydome images/Slide-img5.webp',
    },
    {
      id:6,
      src:'/skydome images/Slide-img6.webp',
    },
  ] 
